'use memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import { NotificationAndResponseHeader } from './_layout/-components/NotificationAndResponseHeader';
export const Route = createFileRoute('/_staff/settings/notification-and-response/_layout')({
  component: RouteComponent
});
function RouteComponent() {
  return <VStack className="gap-0">
      <NotificationAndResponseHeader />
      <Outlet />
    </VStack>;
}